"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sushi = void 0;
exports.sushi = {
    minichef: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    tridentRouter: '0xc5017BE80b4446988e8686168396289a9A62668E',
    complexRewarderTime: '0xa3378Ca78633B3b9b2255EAa26748770211163AE',
};
